import { Outlet } from 'react-router-dom';
import { WarehouseProvider } from 'components/Warehouse';

const WarehouseWrapper = () => {
    return (
        <WarehouseProvider>
            <Outlet />
        </WarehouseProvider> 
    );
};

export default WarehouseWrapper;